// src/analytics/useAnalytics.js

import { useCallback } from 'react'
import { logEvent } from 'firebase/analytics'
import { analytics } from '../firebase'
import { getLocalUserDetails } from './LocalStorage_Handler'

const isProd = process.env.NODE_ENV === 'production'

const analyticsEnabled = process.env.REACT_APP_ENABLE_ANALYTICS === 'true'

const safeLog = (msg, ...args) => {
  if (analyticsEnabled && !isProd) {
    console.log(`[Analytics] ${msg}`, ...args)
  }
}
const useAnalytics = () => {
  const trackEvent = useCallback((eventName, params = {}) => {
    if (!analyticsEnabled) return

    try {
      const userDetails = getLocalUserDetails()
      const subscriptionType = userDetails?.sub?.subTypeName || 'Guest'
      const country = userDetails?.userCountryDetails?.nicename || 'Guest'

      const updatedParams = {
        ...params,
        subscriptionType,
        country
      }

      logEvent(analytics, eventName, updatedParams)
      safeLog(`Event Logged: ${eventName}`, updatedParams)
    } catch (err) {
      console.warn(`Failed to track event: ${eventName}`, err)
    }
  }, [])

  const setScreenLog = useCallback(
    (screenName, params = {}) => {
      if (!analyticsEnabled) return

      trackEvent('web_screen_view', {
        screen_name: screenName,
        page_title: document.title,
        page_location: window.location.href,
        ...params
      })
    },
    [trackEvent]
  )

  return {
    trackEvent,
    setScreenLog
  }
}

export default useAnalytics
